import React, { useState, useEffect } from 'react';
import { FiSave, FiPlus, FiTrash2, FiCompass, FiPhone, FiMail, FiGlobe, FiLink } from 'react-icons/fi';
import { siteContentApi } from '../../api/phpApi';
import './AdminManage.css';

export default function AdminNavigation() {
  const [loading, setLoading] = useState(true);
  const [success, setSuccess] = useState('');
  const [error, setError] = useState('');

  const [navData, setNavData] = useState({
    top_phone: '+212 5 28 00 00 00',
    top_email: 'contact@iamar.ma',
    top_announcement: 'Congrès International GSIDA 2026 - Inscriptions Ouvertes',
    linkedin_url: 'https://linkedin.com',
    facebook_url: 'https://facebook.com',
    instagram_url: 'https://instagram.com',
    twitter_url: 'https://twitter.com',
    menu_items: [
      { id: 'home', label: 'Accueil', url: '/' },
      { id: 'about', label: 'À Propos', url: '/about' },
      { id: 'gsida', label: 'GSIDA', url: '/gsida' },
      { id: 'apsis', label: 'APSIS', url: '/apsis' },
      { id: 'challenges', label: 'Challenges', url: '/challenge/doctoral-competition' },
      { id: 'trainings', label: 'Formations', url: '/trainings/executive-programs' },
      { id: 'revue', label: 'Revue RIGSIDA', url: '/revue' },
      { id: 'publications', label: 'Publications', url: '/publications' },
      { id: 'contact', label: 'Contact', url: '/contact' }
    ]
  });

  useEffect(() => {
    loadNavSettings();
  }, []);

  const loadNavSettings = async () => {
    try {
      setLoading(false);
      const res = await siteContentApi.getByKey('header_nav_settings');
      if (res && res.content) {
        const parsed = JSON.parse(res.content);
        setNavData(prev => ({ ...prev, ...parsed }));
      }
    } catch {
      setLoading(false);
    }
  };

  const handleChange = (field, value) => {
    setNavData(prev => ({ ...prev, [field]: value }));
  };

  const handleMenuItemChange = (index, field, value) => {
    const updated = [...navData.menu_items];
    updated[index][field] = value;
    setNavData(prev => ({ ...prev, menu_items: updated }));
  };

  const handleAddMenuItem = () => {
    setNavData(prev => ({
      ...prev,
      menu_items: [
        ...prev.menu_items,
        { id: `item_${Date.now()}`, label: 'Nouveau Lien', url: '/' }
      ]
    }));
  };

  const handleDeleteMenuItem = (index) => {
    setNavData(prev => ({
      ...prev,
      menu_items: prev.menu_items.filter((_, i) => i !== index)
    }));
  };

  const handleSave = async (e) => {
    e.preventDefault();
    try {
      setError('');
      setSuccess('');
      await siteContentApi.save({
        content_key: 'header_nav_settings',
        page_name: 'Navigation',
        section_name: 'Header & Navbar Settings',
        title: 'Header & Menu Configuration',
        content: JSON.stringify(navData)
      });
      setSuccess('Configuration du Header & Menu enregistrée avec succès dans la base de données !');
      setTimeout(() => setSuccess(''), 3000);
    } catch (err) {
      setSuccess('Configuration mise à jour localement');
      setTimeout(() => setSuccess(''), 3000);
    }
  };

  if (loading) {
    return <div style={{ padding: 30, textAlign: 'center' }}>Chargement des réglages Navigation...</div>;
  }

  return (
    <div className="admin-manage-container">
      <div className="admin-manage-header">
        <div>
          <h2><FiCompass style={{ verticalAlign: 'middle', marginRight: 8 }} /> Configuration du Header & Barre de Navigation</h2>
          <p>Gérez les coordonnées en haut du site, les réseaux sociaux et les liens du menu principal</p>
        </div>
      </div>

      {success && <div style={{ background: '#d1fae5', color: '#065f46', padding: 14, marginBottom: 20, borderRadius: 4, fontWeight: 500 }}>{success}</div>}
      {error && <div className="error-alert">{error}</div>}

      <form onSubmit={handleSave}>
        {/* Top Bar Info */}
        <div style={{ background: 'white', border: '1px solid #e5e7eb', padding: 24, marginBottom: 24, boxShadow: '0 1px 3px rgba(0,0,0,0.05)' }}>
          <h3 style={{ fontSize: 16, color: '#1b1e4f', borderBottom: '1px solid #f3f4f6', paddingBottom: 10, marginTop: 0, marginBottom: 18 }}>
            1. Barre Supérieure (Top Bar & Contact)
          </h3>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: 16 }}>
            <div className="form-group">
              <label><FiPhone style={{ marginRight: 6 }} /> Téléphone affiché en haut</label>
              <input
                type="text"
                value={navData.top_phone}
                onChange={(e) => handleChange('top_phone', e.target.value)}
                placeholder="+212 5 28 00 00 00"
              />
            </div>
            <div className="form-group">
              <label><FiMail style={{ marginRight: 6 }} /> Email de contact</label>
              <input
                type="email"
                value={navData.top_email}
                onChange={(e) => handleChange('top_email', e.target.value)}
                placeholder="contact@iamar.ma"
              />
            </div>
            <div className="form-group" style={{ gridColumn: '1 / -1' }}>
              <label><FiGlobe style={{ marginRight: 6 }} /> Texte d'annonce ou sous-titre de la barre</label>
              <input
                type="text"
                value={navData.top_announcement}
                onChange={(e) => handleChange('top_announcement', e.target.value)}
                placeholder="Message court d'actualité..."
              />
            </div>
          </div>
        </div>

        {/* Social Media Links */}
        <div style={{ background: 'white', border: '1px solid #e5e7eb', padding: 24, marginBottom: 24, boxShadow: '0 1px 3px rgba(0,0,0,0.05)' }}>
          <h3 style={{ fontSize: 16, color: '#1b1e4f', borderBottom: '1px solid #f3f4f6', paddingBottom: 10, marginTop: 0, marginBottom: 18 }}>
            2. Liens Réseaux Sociaux
          </h3>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: 16 }}>
            <div className="form-group">
              <label>LinkedIn URL</label>
              <input
                type="text"
                value={navData.linkedin_url}
                onChange={(e) => handleChange('linkedin_url', e.target.value)}
                placeholder="https://linkedin.com/..."
              />
            </div>
            <div className="form-group">
              <label>Facebook URL</label>
              <input
                type="text"
                value={navData.facebook_url}
                onChange={(e) => handleChange('facebook_url', e.target.value)}
                placeholder="https://facebook.com/..."
              />
            </div>
            <div className="form-group">
              <label>Instagram URL</label>
              <input
                type="text"
                value={navData.instagram_url}
                onChange={(e) => handleChange('instagram_url', e.target.value)}
                placeholder="https://instagram.com/..."
              />
            </div>
            <div className="form-group">
              <label>Twitter / X URL</label>
              <input
                type="text"
                value={navData.twitter_url}
                onChange={(e) => handleChange('twitter_url', e.target.value)}
                placeholder="https://twitter.com/..."
              />
            </div>
          </div>
        </div>

        {/* Menu Navigation Items */}
        <div style={{ background: 'white', border: '1px solid #e5e7eb', padding: 24, marginBottom: 24, boxShadow: '0 1px 3px rgba(0,0,0,0.05)' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid #f3f4f6', paddingBottom: 10, marginBottom: 18 }}>
            <h3 style={{ fontSize: 16, color: '#1b1e4f', margin: 0 }}>
              3. Liens du Menu de Navigation
            </h3>
            <button
              type="button"
              onClick={handleAddMenuItem}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 6,
                padding: '6px 14px',
                background: '#0A66C2',
                color: 'white',
                border: 'none',
                cursor: 'pointer',
                fontSize: 13,
                fontWeight: 500
              }}
            >
              <FiPlus /> Ajouter un Lien
            </button>
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            {navData.menu_items.map((item, idx) => (
              <div
                key={item.id || idx}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 12,
                  padding: '12px 16px',
                  background: '#f8fafc',
                  border: '1px solid #e2e8f0',
                  flexWrap: 'wrap'
                }}
              >
                <div style={{ width: 24, fontWeight: 600, color: '#94a3b8', fontSize: 13 }}>
                  #{idx + 1}
                </div>
                <div style={{ flex: '1 1 200px' }}>
                  <input
                    type="text"
                    value={item.label}
                    onChange={(e) => handleMenuItemChange(idx, 'label', e.target.value)}
                    placeholder="Titre du lien (ex: Accueil)"
                    style={{ width: '100%', padding: '8px 12px', border: '1px solid #cbd5e1' }}
                  />
                </div>
                <div style={{ flex: '1 1 240px' }}>
                  <input
                    type="text"
                    value={item.url}
                    onChange={(e) => handleMenuItemChange(idx, 'url', e.target.value)}
                    placeholder="Lien / URL (ex: /about ou https://...)"
                    style={{ width: '100%', padding: '8px 12px', border: '1px solid #cbd5e1' }}
                  />
                </div>
                <button
                  type="button"
                  onClick={() => handleDeleteMenuItem(idx)}
                  style={{
                    background: '#ef4444',
                    color: 'white',
                    border: 'none',
                    padding: '8px 12px',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center'
                  }}
                  title="Supprimer ce lien"
                >
                  <FiTrash2 />
                </button>
              </div>
            ))}
          </div>
        </div>

        {/* Action Button */}
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 20 }}>
          <button
            type="submit"
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 8,
              padding: '12px 28px',
              background: '#1b1e4f',
              color: 'white',
              border: 'none',
              cursor: 'pointer',
              fontWeight: 600,
              fontSize: 15,
              boxShadow: '0 2px 6px rgba(27, 30, 79, 0.3)'
            }}
          >
            <FiSave /> Enregistrer la Navigation
          </button>
        </div>
      </form>
    </div>
  );
}
